<template>
  <div class="dashboard-container">
    <!-- 客资管理     -->
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="120px">
          <!-- <el-row :gutter="2">
            <el-col :span="6"> -->
          <el-form-item label="订单号查询:">
            <el-input v-model="customerId" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <!-- </el-col>
             <el-col :span="6"> -->
          <el-form-item label="微信查询:">
            <el-input v-model="searchWx" placeholder="请输入微信号" clearable></el-input>
          </el-form-item>
          <!-- </el-col>
             <el-col :span="6"> -->
          <el-form-item label="学生姓名:">
            <el-input v-model="searchStudent" placeholder="请输入学生姓名" clearable></el-input>
          </el-form-item>
          <!-- </el-col>
             <el-col :span="6"> -->
          <el-form-item label="类型查询:">
            <el-select v-model="searchType" clearable placeholder="请选择类型" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option label="微信号" value="1"></el-option>
              <el-option label="微信二维码" value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col>
              <el-col :span="6"> -->
          <el-form-item label="微信状态(新):">
            <el-select v-model="searchStatus" clearable placeholder="请选择状态" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option label="新客" value="1"></el-option>
              <el-option label="通过" value="2"></el-option>
              <el-option label="未通过" value="3"></el-option>
              <el-option label="不存在" value="4"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="微信状态(旧):">
            <el-select v-model="customerStateOld" clearable placeholder="请选择状态" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option label="新客" value="1"></el-option>
              <el-option label="通过" value="2"></el-option>
              <el-option label="未通过" value="3"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- </el-col>
              <el-col :span="6"> -->
          <el-form-item label="成单状态:">
            <el-select v-model="type" clearable placeholder="请选择状态" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option label="未成单" value="1"></el-option>
              <el-option label="成单" value="2"></el-option>
              <el-option label="待成单" value="0"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="意向度:">
            <el-cascader :show-all-levels="false" v-model="IntentionLevel" :options="IntentionLevelList" :props="IntentionLevelprops"></el-cascader>
          </el-form-item>
          
          <!-- </el-col>
              <el-col :span="6"> -->
          <el-form-item label="老师姓名:">
            <el-select @clear="handleClear" clearable id="teacher" class="select" v-model="searchTeacherId"
              placeholder="请选择老师" filterable>
              <el-option v-for="teacher in teachers" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col>
              <el-col :span="6"> -->
          <el-form-item label="客资来源:">
            <el-select @clear="handleClear" filterable v-model="searchSource" clearable placeholder="请选择客资来源">
              <el-option v-for="item in sources" :key="item.sourceId" :label="item.sourceName"
                :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col>
              <el-col :span="6"> -->
          <!-- <el-form-item label="添加方式:">
            <el-select v-model="initiative" filterable clearable placeholder="请选择状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="主动" value="1"></el-option>
              <el-option label="被动" value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- </el-col>
              <el-col :span="6"> -->
          <el-form-item label="客资来源负责人:">
            <el-select v-model="searchSourcesPeople" filterable clearable @clear="handleClear" placeholder="请选择客资来源负责人">
              <el-option v-for="item in sourcesPeople" :key="item.sourcepeopleId" :label="item.sourcepeopleName"
                :value="item.sourcepeopleId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="销售:">
            <el-select v-model="inputAcount" clearable filterable placeholder="请选择销售" :filter-method="handleChangeName" >
              <el-option v-for="item in optionsList" :key="item.id" :label="item.label"   :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="渠道:">
            <el-select v-model="channelType" clearable filterable placeholder="请选择渠道">
              <el-option
                v-for="teacher in channelLsit"
                :key="teacher.dictType"
                :value="teacher.dictType"
                :label="teacher.dictValue">
            </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="创建时间:">
            <el-date-picker
              v-model="startTimeList"
              clearable
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="所在地域:">
            <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="投流状态:">
            <el-select v-model="trafficSource" filterable clearable placeholder="请选择状态">
              <el-option label="自然流" value="1"></el-option>
              <el-option label="付费流" value="2"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- </el-col>
              <el-col :span="8"> -->
          <el-form-item>
            <div class="button" flex="auto" style="margin-left:10px">
              <el-button icon="el-icon-close" @click="handleClear" size="small" class="btn">清除</el-button>
              <el-button icon="el-icon-search" type="primary" @click="handleSearch" size="small" class="btn">搜索</el-button>
              <el-button type="primary" icon="el-icon-download" @click="handleDownload" size="small" class="btn">导出</el-button>
            </div>
          </el-form-item>
          <!-- </el-col>
          </el-row>   -->
        </el-form>
        <el-table  :data="list"   :header-cell-style="{   background: '#fafafa',   'text-align':'center'  }" :cell-style="{'text-align':'center'}" border  height="700" >
          <el-table-column prop="customerId" label="订单号" >
            <template slot-scope="scope"> {{ scope.row.customerId }} </template>
          </el-table-column>
          <el-table-column prop="customerWx" label="微信号" width="110" > </el-table-column>
          <el-table-column prop="regionName" label="所在地域" width="110" ></el-table-column>
          <el-table-column prop="channelType" label="渠道" width="110" >
            <template slot-scope="scope">
                <div v-if="scope.row.channelType === 1">线上</div>
                <div v-if="scope.row.channelType === 2">线下</div>
                <div v-if="scope.row.channelType === 3">转介绍</div>
            </template>
          </el-table-column>
          <el-table-column label="微信添加状态(新)" width="180" header-align="center" >
            <template slot-scope="scope">

                <span v-if="scope.row.customerState === 1">新客</span>
                <span v-if="scope.row.customerState === 2">通过</span>
                <span v-if="scope.row.customerState === 3">未通过</span>
                <span v-if="scope.row.customerState === 4">不存在</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="customerAccountName" label="销售" width="110" >
              <template slot-scope="scope">
                <span v-if="scope.row.customerAccount === '10015'">杨佳琪</span>
                <span v-else-if="scope.row.customerAccount === '10014'">王威</span>
                <span v-else-if="scope.row.customerAccount === '15210610322'">陈铮</span>
                <span v-else-if="scope.row.customerAccount === '17620487163'">邓乔</span>
                <span v-else-if="scope.row.customerAccount === '18768101243'">赵薇</span>
                <span v-else-if="scope.row.customerAccount === '15201251274'">苏芮</span>
                <span v-else>{{ scope.row.customerAccountName }}</span>
              </template>
          </el-table-column>
          <el-table-column label="成单状态" width="100px" header-align="center" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">未成单</span>
              <span v-if="scope.row.type === 2">已成单</span>
              <span v-if="scope.row.type === 0">待成单</span>
            </template>
            
          
          </el-table-column>


          <el-table-column prop="intentionName" label="意向度" width="110" ></el-table-column>


       
          <el-table-column prop="customerTeacherName" label="老师" width="100" >
            <template slot-scope="scope">
              <span v-if="scope.row.customerTeacherid === 1">小单老师</span>
              <span v-if="scope.row.customerTeacherid === 2">大单老师</span>
              <span v-if="scope.row.customerTeacherid === 3">刘老师</span>
              <span v-if="scope.row.customerTeacherid === 4">杨老师</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerStudent" label="学生姓名" width="120" ></el-table-column>

          <el-table-column prop="sourceName" label="客资来源" width="100" ></el-table-column>
          <el-table-column prop="sourcepeopleName" label="来源负责人" width="100" ></el-table-column>
          
          <el-table-column prop="createTime" label="创建时间" width="180" >
          </el-table-column>

          <el-table-column  header-align="center" label="操作" width="100px">
            <template slot-scope="scope">
              <!-- 老样式 -->
              <!-- <el-button type="text" @click="edit(scope.row.customerId, false)">编辑</el-button>
              <el-button type="text" @click="edit(scope.row.customerId, true)">详情</el-button> -->

              <!-- 新样式 -->
              <el-button type="text" @click="editNew(scope.row.customerId, '编辑')">编辑</el-button>
              <el-button type="text" @click="editNew(scope.row.customerId, '详情')">详情</el-button>



              <!--                <el-button type="text" @click="deleteCustomer(scope.row.customerId)">-->
              <!--                  删除-->
              <!--                </el-button>-->
            </template>
          </el-table-column>
        </el-table>


        <!-- 图片弹层 -->
        <el-dialog :visible.sync="previewDialogVisible" width="60%" class="custom-dialog">
          <img :src="previewImageUrl" style="max-width: 100%; max-height: 100%;" />
        </el-dialog>

        <!--         详情编辑弹窗 -->
        <customer-upd-or-det ref="addOrUpdCustomer" @refresh="refresh"></customer-upd-or-det>
        <!--         分页 -->

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="requestParameters.currentpage" :page-size="requestParameters.pagesize"
          layout="prev, pager, next,sizes, jumper" :total="total" style="text-align: end;padding-top: 30px;">
        </el-pagination>
        <!--        成单编辑弹窗-->
        <order-update ref="orderUpdate" @resetSuccesType="resetSuccesType" @refresh="refresh"></order-update>
      </el-card>
    </div>









    <el-drawer  :title="drawerTitle"  size="55%" :visible.sync="drawerShow"   direction="rtl"  :before-close="handleDrawerClose">

      <div style="display: flex;width: 100%;">

        <div style="width: 50%;">
          <h4>客资信息</h4>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">学生姓名:</span>
            <el-input :disabled="detail === '详情'" style="" size="small" v-model="customerStudent1" placeholder="请输入学生姓名" clearable></el-input>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">手机号码:</span>
            <el-input :disabled="detail === '详情'" style="" size="small" maxlength="11" v-model="parentPhoneNumber1" placeholder="请输入手机号码" clearable></el-input>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">微信号:</span>
            <el-input :disabled="detail === '详情'" style="" size="small" v-model="searchWxs" placeholder="请输入学生姓名" clearable></el-input>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">所属地域:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="regionName1" clearable placeholder="请选择所属地域" filterable>
              <el-option style="margin-left: 10px;" v-for="customerSource in customerSourceIdss" :key="customerSource.id" :label="customerSource.dictValue" :value="customerSource.dictType"></el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">渠道:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="channelType1" clearable placeholder="请选择渠道" filterable>
              <el-option v-for="teacher in channelLsit"  :key="teacher.dictType"  :value="teacher.dictType"  :label="teacher.dictValue"> </el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">客资来源:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="searchType1" clearable placeholder="请选择客资来源" filterable>
              <el-option v-for="item in sources" :key="item.sourceId" :label="item.sourceName"  :value="item.sourceId"></el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">客资来源负责人:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="searchType2" clearable placeholder="请选择客资来源负责人" filterable>
              <el-option v-for="item in sourcesPeople" :key="item.sourcepeopleId" :label="item.sourcepeopleName"  :value="item.sourcepeopleId"></el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">添加方式:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="searchType3" clearable placeholder="请选择添加方式" filterable>
              <el-option label="主动" :value="1"></el-option>
              <el-option label="被动" :value="2"></el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">所属销售:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="searchType4" clearable placeholder="请选择所属销售" filterable  :filter-method="handleChangeName1" >
              <el-option v-for="item in optionsList1" :key="item.id" :label="item.label"   :value="item.id"></el-option>
            </el-select>
          </div>

          <div style="display: flex;padding: 10px;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">IP老师姓名:</span>
            <el-select style="width: 100%;" :disabled="detail === '详情'" size="small" v-model="searchType5" clearable placeholder="请选择IP老师姓名" filterable>
              <el-option v-for="teacher in teachers" :key="teacher.value" :value="teacher.value" :label="teacher.label"></el-option>
            </el-select>
          </div>

          

        </div>
        
        
        <div style="width: 50%;">
          <h4>跟进信息</h4>

          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">微信状态:</span>
            <el-radio-group :disabled="detail === '详情'" size="small" v-model="searchType6" @change="handlesearchType6" style="display: flex;flex-wrap: wrap;">
              <el-radio style="width: 50%;" :label="1">新客</el-radio>
              <el-radio style="width: 50%;" :label="2">通过</el-radio>
              <el-radio style="width: 50%;" :label="3">未通过</el-radio>
              <el-radio style="width: 50%;" :label="4">不存在</el-radio>
            </el-radio-group>
          </div>


          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">成单状态:</span>
            <el-radio-group :disabled="detail === '详情'" size="small" v-model="searchType7" style="display: flex;flex-wrap: wrap;width: 65%;">
              <el-radio style="width: 40%;" :label="1" :disabled="searchType6 != 2">未成单</el-radio>
              <el-radio style="width: 40%;" :label="2" :disabled="searchType6 != 2">已成单</el-radio>
              <el-radio style="width: 40%;" :label="0">待成单</el-radio>
            </el-radio-group>
          </div>


          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">意向度:</span>
            <el-cascader  size="small" style="width: 60%;" :disabled="detail === '详情'" :show-all-levels="false" v-model="IntentionLevels" :options="IntentionLevelLists" :props="IntentionLevelpropss"></el-cascader>
          </div>


          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">学生当前年级:</span>
            <el-cascader style="width: 60%;" :disabled="detail === '详情'" clearable size="small"  v-model="grade" :options="gradeList" :props="props"></el-cascader>
          </div>


          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">备注:</span>
            <el-input  :disabled="detail === '详情'" style=" width: 60%;" type="textarea" size="small"   placeholder="请输入内容"   v-model="textarea"  maxlength="9999999" >  </el-input>
          </div>


          <div style="display: flex;padding: 10px;text-align: start;">
            <span style="width: 120px; margin-top: 5px;margin-right: 10px;">跟进记录:</span>
          </div>

          <div style="padding: 10px; padding-top: 20px;">
            <div style="overflow: auto;"  :style="{ height:  isShowTop ? '300px' : '100px'}">
              <el-timeline>
                <el-timeline-item  v-for="(activity, index) in activities"  :key="index" >

                  <div style="font-size: 12px;padding-top: 10px;margin-bottom: 5px;">
                   意向度： {{activity.intentionName}}
                  </div>

                  <div style="font-size: 12px;padding-top: 5px;margin-bottom: 5px;">
                   备注： {{activity.remark}}
                  </div>

                  <div style="font-size: 12px;padding-top: 5px;margin-bottom: 5px;">
                   时间： {{activity.remarkDate}}
                  </div>
                 
                </el-timeline-item>
              </el-timeline>
            </div>

            <div style="text-align: start;padding-left: 70px;margin-top: 40px;">
              <span @click="handleTop" style="color: rgb(239, 140, 12);">{{ isShowTop ? '收起跟进记录' : '更多跟进记录' }}</span>
              <i v-if="!isShowTop"  class="el-icon-arrow-down" style="color: rgb(239, 140, 12);"></i>
              <i v-if="isShowTop"  class="el-icon-arrow-up" style="color: rgb(239, 140, 12);"></i>
            </div>
          </div> 

        </div>

      </div>

      <div style="position: absolute;  bottom: 22px;  right: 22px;">
        <el-button style="width: 57px;height: 30px;border-radius: 6px;line-height: 1px;padding-left: 14px;" @click="handleClose">取消</el-button>
        <el-button v-if="detail === '编辑'" style="width: 57px;height: 30px;border-radius: 6px;line-height: 1px;padding-left: 14px;" type="warning" @click="handleSubt">保存</el-button>
      </div>

    </el-drawer>






  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import axios from "axios";
import CustomerUpdOrDet from './components/CustomerUpdOrDet.vue';
import OrderUpdate from "./components/OrderUpdate.vue";
import { options } from "@fullcalendar/core/preact";

export default {
  components: {
    OrderUpdate, //成单编辑
    CustomerUpdOrDet //详情和编辑弹窗
  },
  data () {
    return {

      isShowTop:false,


      customerStudent1: '',
      parentPhoneNumber1: '',
      searchWxs: '',
      regionName1: '',
      channelType1: '',
      searchType1: '',
      searchType2: '',
      searchType3: '',
      searchType4: '',
      searchType5: '',
      searchType6: '',
      searchType7: 0,

      activities: [],

      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },

      textarea: '',

      grade:[],
      gradeList:[],

      IntentionLevel:[],
      IntentionLevelList:[
        {
          name:'全部意向度',
          id:'',
        },
        {
          name:'无效客资',
          id:0,
          children:[
            {
              name:'回访-电话3次未接通',
              id:1,
            },
            {
              name:'无意向/不需要/无需求',
              id:2,
            },
            {
              name:'空号',
              id:3,
            },
          ]
        },
        {
          name:'有效客资',
          id:1,
          children:[
            {
              name:'回访-电话接通',
              id:4,
            },
            {
              name:'回访-发现意向',
              id:5,
            },
            {
              name:'回访-高潜成交',
              id:6,
            },
            {
              name:'回访-成单客户',
              id:7,
            },
            {
              name:'课前咨询',
              id:8,
            },
          ]
        },
      ],
      IntentionLevelprops: {
        label: "name",
        children: "children",
        value: "id"
      },


      IntentionLevels:[],
      IntentionLevelLists:[
        {
          name:'无效客资',
          id:0,
          children:[
            {
              name:'回访-电话3次未接通',
              id:1,
            },
            {
              name:'无意向/不需要/无需求',
              id:2,
            },
            {
              name:'空号',
              id:3,
            },
          ]
        },
        {
          name:'有效客资',
          id:1,
          children:[
            {
              name:'回访-电话接通',
              id:4,
            },
            {
              name:'回访-发现意向',
              id:5,
            },
            {
              name:'回访-高潜成交',
              id:6,
            },
            {
              name:'回访-成单客户',
              id:7,
            },
            {
              name:'课前咨询',
              id:8,
            },
          ]
        },
      ],
      IntentionLevelpropss: {
        label: "name",
        children: "children",
        value: "id"
      },

      drawerShow: false,
      drawerTitle: '',

      channelType:'',
      startTimeList:[],
      customerId: "",//订单号
      list: [],
      inputAcount:"",
      regionName:'',
      trafficSource:'',
      channelLsit:[
        {dictValue:"线上", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"转介绍", dictType:3 },
      ],
      optionsList:[
        

      ],
      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],
      teachers: [
        {
          value: 1,
          label: "小单老师"
        },
        {
          value: 2,
          label: "大单老师"
        },
        {
          value: 3,
          label: "刘老师"
        },
        {
          value: 4,
          label: "杨老师"
        },
        {
          value: 4,
          label: "线下老师"
        }
      ], //；老师
      address: "",
      total: 0, //总条数
      url: "",
      sources: [], //客资来源列表
      sourcesPeople: [], //客资来源负责人列表
      searchWx: "", // 输入的微信号
      searchStudent: "", //学生姓名
      searchTeacherId: "",  //老师姓名
      searchStatus: "", //选择的状态
      customerStateOld:'',
      type: "",//成单状态
      initiative: "",//状态
      searchSource: "",//客资来源
      searchSourcesPeople: "",//来源负责人
      searchAdd: "",//选择添加方式
      selectedState: "",
      searchType: "", //选择类型
      stateList: [],
      d: [],
      studentName: "", // 保存学生姓名的变量
      deleteCustomerId: null,
      searchKeyword: "",
      requestParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1 //当前显示页码
      },
      showEdit: false, // 控制弹层显示/隐藏的变量
      srcList: [], // 预览图像的原始链接列表
      previewImageUrl: "", // 当前预览图像的链接
      previewDialogVisible: false, // 大图预览对话框是否可见

      optionsList1:[],
      customerSourceIdss:[],


      detail:'',
      customerIds:'',


    };
  },
  created () {

    this.getDataSourse();
    this.getDataSoursePeople();
    this.getcityOptions()
    setTimeout(() => {
      this.getList();
    },1000)
  },

  mounted () {
    this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
    this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))

    axios.get(`${apiBaseUrl}/grade/getGrade`,{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
           }
    })

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
      this.customerSourceIdss = res.data.data
    })

    axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: '' },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
       if (res.data.code == 200) {
         let datas = res.data.data.map(fore => {
             fore.id = fore.telephone
             fore.saleId = fore.saleId
             fore.label = fore.saleName 
             return fore
         })
         this.optionsList = datas
       }else{
         this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
       }
     })
      
  },
  methods: {

    handleChangeName(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.optionsList = datas
          }else{
            this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleChangeName1(value) {
       if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.optionsList1 = datas
          }else{
            this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleTop(){
      this.isShowTop = !this.isShowTop
    },

    editNew (id, type) {

        this.drawerShow = true;

        if (type === '编辑') {
          this.drawerTitle = '客资编辑';
          
        } 
        
        if (type === '详情') {
          this.drawerTitle = '客资详情';
        }


        this.initeditNew(id, type)

    },

    initeditNew (customerId, detail) {
      this.detail = detail
      this.customerIds = customerId

      axios.get( `${apiBaseUrl}/customerinformation/customersone/${customerId}` ,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {

          console.log(response.data, '11111111111111111111111111111111>>>>>>>>>>>>>>>>>>>w')

          if(response.data.code === 200){
            let data = response.data.data.list
            this.customerStudent1 = data.customerStudent
            this.parentPhoneNumber1 = data.parentPhoneNumber
            this.searchWxs = data.customerWx
            this.regionName1 = Number(data.regionName)
            this.channelType1 = data.channelType
            this.searchType1 = data.customerSource
            this.searchType2 = data.customerSourcepeople
            this.searchType3 = data.customerIsactive
            this.searchType4 = data.customerAccount
            this.searchType5 = data.customerTeacherid
            this.searchType6 = data.customerState
            this.searchType7 = data.type ? data.type : 0
            this.grade = data.grade ? JSON.parse(data.grade) : []

            this.IntentionLevels = [data.intentionStair,data.intentionSecond]



            if(data.clientNeedRemark){
              let newList = JSON.parse(data.clientNeedRemark);
              this.activities = newList.filter(item => item != null);
            }else{
                this.activities = [];
            }
          }else{
            this.$message({ message: response.data.msg, type: 'error'  })
          }

         
        }).catch(error => {
          console.error(error);
        })
    },

    handleDrawerClose () {
      this.drawerShow = false;
      this.drawerTitle = '';
      this.customerStudent1 = ''
      this.parentPhoneNumber1 = ''
      this.searchWxs = ''
      this.regionName1 =  ''
      this.channelType1 = ''
      this.searchType1 = ''
      this.searchType2 = ''
      this.IntentionLevels = []
      this.searchType3 = ''
      this.searchType4 = ''
      this.searchType5 = ''
      this.searchType6 = ''
      this.searchType7 = 0
      this.grade =  []
      this.textarea = ''
      this.activities = []
    },

    handleClose () {
      if(this.detail === '详情'){
        this.handleDrawerClose();
      }else{
        this.$confirm('确认不保存当前内容','确认信息',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'custom-confirm-button', // 可以自定义 class
            confirmButtonType: 'primary', // 默认就是 primary，你可以换成 danger 等
            type: 'warning'
        }).then(_ => {
          this.handleDrawerClose();
        }) .catch(_ => {});
      }
      
    },

    getCurrentTime () {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleSubt(){
      // let clientNeedRemarkLenth = this.activities.length   
      // if(this.textarea){
      //   this.activities[clientNeedRemarkLenth + 1] = { remark: this.textarea, remarkDate: this.getCurrentTime() }
      // }

      if(this.parentPhoneNumber1 && this.parentPhoneNumber1.length < 11){
        this.$message({ message: '请输入正确的手机号', type: 'warning'  })
        return
      }

      let data = {
          customerId:this.customerIds,
          customerStudent: this.customerStudent1 ? this.customerStudent1 : '',
          parentPhoneNumber: this.parentPhoneNumber1 ? this.parentPhoneNumber1 : '',
          customerWx: this.searchWxs,
          regionName: this.regionName1,
          channelType: this.channelType1,
          customerSource: this.searchType1,
          customerSourcepeople: this.searchType2 ,
          customerIsactive: this.searchType3 ,
          customerAccount: this.searchType4,
          customerTeacherid: this.searchType5,
          customerState: this.searchType6,
          type: this.searchType7,
          grade: this.grade && this.grade.length > 0 ? JSON.stringify(this.grade) : '',
          // clientNeedRemark: this.activities && this.activities.length > 0 ? JSON.stringify(this.activities) : '',
          remark:this.textarea,
          intentionStair: this.IntentionLevels.length > 0 ? this.IntentionLevels[0] : '',
          intentionSecond: this.IntentionLevels.length > 1 ? this.IntentionLevels[1] : '',
      }
      axios.put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
          if (response.data.code === 200) {
            this.$message({message: '修改成功',  type: 'success' })
            this.handleDrawerClose();
            this.getList ()
          }else{
            this.$message({ message: response.data.msg, type: 'error'  })
          }
        }).catch(error => {
          this.$message({ message: '修改失败', type: 'error'  })
          console.error(error);
        });
    },



    refresh () {
      this.handleSearch()
    },
    getcityOptions(){
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data

      })
    },
    //查询列表
    getList () {

      const data = {
        customerId: this.customerId,
        page: this.requestParameters.currentpage,
        limit: this.requestParameters.pagesize,
        customerAccount: "",
        customerWx: this.searchWx, //要查询的微信号
        customerState: this.searchStatus,//选择状态
        customerStateOld:this.customerStateOld,
        searchTeacherId: this.searchTeacherId, //老师姓名
        searchStudent: this.searchStudent,
        searchSource: this.searchSource, //客资来源
        searchSourcesPeople: this.searchSourcesPeople,// 来源负责人
        order: this.order, //成单状态
        initiative: this.initiative, //状态
        customerIsactive: this.searchAdd,//选择添加方式
        customerType: this.searchType,
        type: this.type,
        account: this.inputAcount,
        channelType: this.channelType,
        startTime: this.startTimeList[0],
        endTime: this.startTimeList[1],
        // regionName: this.regionName || localStorage.getItem('cityTepy').split(',').map(Number),
        regionName: this.regionName || localStorage.getItem('cityTepy'),
        trafficSource:this.trafficSource,

        intentionStair: this.IntentionLevel.length > 0 ? this.IntentionLevel[0] : '',
        intentionSecond: this.IntentionLevel.length > 1 ? this.IntentionLevel[1] : '',

      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        data.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          data.customerAccount = JSON.parse(teacher).adminNo;
        }
      }
      axios
        .post(`${apiBaseUrl}/customerinformation/customerinformationlist`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.list = response.data.data.list;
          this.total = response.data.data.count; // 更新总条数
        })
        .catch(error => {

        });
    },
    getDataSourse () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.sources = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },

    handlesearchType6(e){
      if(e == 2){

      }else{
        this.searchType7 = 0
        
      }
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //查询状态
    handleStateChangeold (row) {
      const { customerId, customerStateOld } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
          customerId: customerId,
          customerStateOld: customerStateOld
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {

          // 更新数据成功后，进行相应的操作
          this.stateList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "客资状态保存成功",
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "客资状态未保存",
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(error => {

        });
    },
    handleStateChange (row) {
      const { customerId, customerState } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
          customerId: customerId,
          customerState: customerState
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {

          // 更新数据成功后，进行相应的操作
          this.stateList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "客资状态保存成功",
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "客资状态未保存",
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(error => {

        });
    },
    //添加方式：主动/被动
    handleAddChange (row) {
      const { customerId, customerIsactive } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerisactiveupdate`, {
          customerId: customerId,
          customerIsactive: customerIsactive
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {

          // 更新数据成功后，进行相应的操作
          this.addList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "添加方式保存成功",
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "添加方式保存未保存",
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(error => {

        });
    },
    resetSuccesType (customer) {
      customer.type = 1
    },

    //删除
    deleteCustomer (customerId) {
      this.$confirm("确定删除该条客资信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios
            .delete(
              `${apiBaseUrl}/customerinformation/customerdelete/${customerId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
            )
            .then(response => {

              if (response.data.code === 200) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                //失败
                this.$message.error("删除失败");
              }
            })
            .catch(error => {

              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    //图片预览
    handlePreview (url) {
      if (!this.srcList.includes(url)) {
        this.srcList.push(url);
      }
      this.previewImageUrl = url;
      this.previewDialogVisible = true;
    },
    //分页
    handleSizeChange (pageSize) {
      this.requestParameters.pagesize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getList(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.currentpage = newPage;
      this.getList();
    },
    //清除
    handleClear () {
      this.inputAcount = ""
      this.channelType = ""
      this.customerId = ""
      this.searchWx = ""; // 清除查询内容
      this.searchStatus = ""; // 清除状态
      this.customerStateOld = "";
      this.IntentionLevel = []
      this.searchType = ""; // 清除类型
      this.searchTeacherId = ""; // 清除老师
      this.searchSource = ""; //清除来源
      this.searchSourcesPeople = ""; //清楚负责人
      this.initiative = "" // 主动/状态
      this.type = "" //成单状态
      this.searchStudent = "" //学生姓名
      this.regionName = ""
      this.trafficSource = ''
      this.startTimeList = [];
      this.getList()
    },
    // 搜索
    handleSearch () {
      this.requestParameters.currentpage = 1;
      this.getList();
    },
    //修改学生弹窗
    showEditDialog () {
      this.edit(); // 在打开编辑弹层时调用获取数据的方法
      this.showEdit = true;
    },
    closeEditDialog () {
      this.showEdit = false;
    },
    // 编辑表单
    saveEditForm () {
      // 保存编辑表单的逻辑
      // 将编辑后的数据提交给后端 API
      // ...
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, {
          customerStudent: this.studentName,
          customerId: this.customerId
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 1000
            });
            this.showEdit = false;
            this.getList();
          } else {
            this.$message({ error: "修改失败", type: "error", duration: 1000 });
          }
        })
        .catch(
          error =>
            function () {
              this.$message({
                error: "修改失败",
                type: "error",
                duration: 1000
              });
            }
        );
    },
    //编辑
    edit (customerId, detail) {
      this.$nextTick(() => {
        this.$refs.addOrUpdCustomer.init(customerId, detail)
      })
    },
    //回显学生姓名并修改
    getStudent () {
      const data = {
        customerStudent: "",
        customerId: ""
      };
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate${data}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {

        })
        .catch(error => {

        });
    },
    //成交状态
    handleChangeType (customer) {
      this.$confirm(`确定修改客资成交状态吗？<span style="color: red">成交状态只可修改一次!</span>`, `提示`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(() => {
        this.$refs.orderUpdate.orderShow(customer)
      }).catch(() => {
        customer.type = 1
        this.$message({
          type: 'info',
          message: '已取消操作',
        })
      })
    },
    //导出客资
    handleDownload () {
      // 定义要传递的参数
      const params = {
        customerStudent: "", // 姓名
        customerAccount: "", //账号
        customerWx: this.searchWx, //要查询的微信号
        customerState: this.searchStatus, //选择状态
        customerStateOld:this.customerStateOld,
        customerIsactive: this.searchAdd, //选择添加方式
        customerType: this.searchType,
        startTime: this.startTimeList.length > 0 ? this.startTimeList[0] : null,
        endTime: this.startTimeList.length > 0 ? this.startTimeList[1] : null,
        intentionStair: this.IntentionLevel.length > 0 ? this.IntentionLevel[0] : '',
        intentionSecond: this.IntentionLevel.length > 1 ? this.IntentionLevel[1] : '',
        account: this.inputAcount,

      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        params.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          params.customerAccount = JSON.parse(teacher).adminNo;
        }
      }

      axios
        .post(
          `${apiBaseUrl}/customerinformation/customerinformationexceloutput`,
          params,
          { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
         } // 设置responseType为'blob'以接收二进制数据
        )
        .then(response => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel"
          }); // 从响应中获取Blob对象
          const downloadLink = document.createElement("a"); // 创建一个下载链接
          downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
          downloadLink.download = "客资信息.xlsx"; // 设置下载文件的文件名
          //

          downloadLink.click(); // 触发下载
        })
        .catch(error => {

        });
    },
  }
};
</script>

<style lang="less" scoped>

/deep/ .el-timeline-item__wrapper{
  text-align: start;
}

.order {
  margin-left: -15px;
}

.demo-form-inline {
  /* height: 35px; */
  display: flex;
  flex-wrap: wrap;
}

.cor {
  border-radius: 5px;
  margin-top: 10px;
  background-color: #f4f4f5;
}

/* .el-form-item {
  width: 281px;
}

.num {
  padding: 10px;
  color: #ccc;
  font-size: 13px;
} */

.el-icon-info {
  margin-right: 5px;
}

.cg {
  /* flex: 1; */
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}
/deep/ .el-radio{
  display: block;
  line-height: 23px;
  white-space: normal;
  margin-right:0;
  text-align: justify;
}

::v-deep.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 5px 0 0 !important;
  box-sizing: border-box;
}

.page {
  position: fixed;
  bottom: 0;
  width: 80%;
}

.custom-dialog {
  overflow: auto;
}

.parent-container {
  position: relative;
}




/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa /deep/ .el-dialog {
    width: 70% !important;
  }
}

.btn{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.custom-confirm-button {
  background-color: #ef952e !important; /* 自定义确认按钮的背景色 */
  border-color: #ef952e !important; /* 自定义确认按钮的边框颜色 */
}


/deep/ .el-timeline-item__tail{
  background-color: #ef952e !important; /* 自定义确认按钮的背景色 */
  margin-top: 12px;
}
/deep/ .el-timeline-item__node{
    background-color: #ef952e !important; /* 自定义确认按钮的背景色 */
    margin-top: 12px;
}

</style>



// WEBPACK FOOTER //
// src/manager/CustomerMange.vue